import { CAPSINTERNET, POSTPAID, SUNRISEINTERNET, SUNRISEMOBILE } from "../../Analytics/AnalyticsConstants";

export const CheckBenefitsMatch = (
    userBenefitsSelectedCheckBox: any[],
    userSubscriptionData: any[]
  ) => {
    let benefitsMatch = false;
    const subscriptionData = userSubscriptionData?.map((data: any) => {
      return data?.ratePlanType;
    });
    if (
      userBenefitsSelectedCheckBox?.includes(SUNRISEMOBILE) &&
      userBenefitsSelectedCheckBox?.includes(SUNRISEINTERNET)
    ) {
      if (subscriptionData?.includes(POSTPAID) && subscriptionData?.includes(CAPSINTERNET)) {
        benefitsMatch = true;
      }
    } else {
      if (
        userBenefitsSelectedCheckBox?.includes(SUNRISEMOBILE) &&
        subscriptionData?.includes(POSTPAID)
      ) {
        benefitsMatch = true;
      }
      if (
        userBenefitsSelectedCheckBox?.includes(SUNRISEINTERNET) &&
        subscriptionData?.includes(CAPSINTERNET)
      ) {
        benefitsMatch = true;
  
    }
    }
    return benefitsMatch;
  };